<header class="site-header">
  <nav class="navbar navbar-expand-lg main-navbar">
    <div class="container-fluid px-3 px-lg-4">
      <a class="navbar-brand d-flex align-items-center gap-2" routerLink="/">
        <img src="assets/images/logo.png" alt="UMYO Gossip" class="brand-logo" onerror="this.style.display='none'">
        <span class="brand-text">
          UMYO <span class="text-pink">GOSSIP</span>
          <small class="d-block">DIRECTORY</small>
        </span>
      </a>

      <button class="menu-btn d-flex d-md-none navbar-toggler"
        type="button"
        (click)="isNavOpen = !isNavOpen"
        [attr.aria-expanded]="isNavOpen"
        aria-controls="navbarNav"
        aria-label="Toggle navigation"
      >
        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 6h18M3 12h18M3 18h18"/>
        </svg>
      </button>

      <div class="navbar-collapse justify-content-center" id="navbarNav" [class.show]="isNavOpen">
        <ul class="navbar-nav main-nav">
          <li class="nav-item"><a class="nav-link " routerLink="/" (click)="isNavOpen = false">Home</a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/directory" (click)="isNavOpen = false">Directory</a></li>
          <li class="nav-item"><a class="nav-link " routerLink="/packages" (click)="isNavOpen = false">Packages</a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/platforms" (click)="isNavOpen = false">Platforms</a></li>
          <li class="nav-item">
            <a class="nav-link" href="/assets/creat-card/index.html" target="_self">Creat Your Card</a>
          </li>
          <li class="nav-item"><a class="nav-link" routerLink="/hardship" (click)="isNavOpen = false">Harships Incentives</a></li>
        </ul>
      </div>
      <div class="d-none d-md-flex align-items-center gap-2">
        <a href="/?authTab=login#login" class="btn btn-outline-pink btn-sm-pad">LOGIN</a>
        <a href="/?authTab=register#register" class="btn btn-pink">
          REGISTER NOW
        </a>
      </div>
    </div>
  </nav>
</header>

<!-- ============ HERO ============ -->
<section class="tc-hero">
  <div class="container" style="position:relative;z-index:1;">
    <span class="hs-eyebrow">LEGAL &amp; PLATFORM POLICIES</span>
    <h1 class="tc-hero-title">
      PRIVACY<br>
      <span class="text-pink">POLICY.</span>
    </h1>
    <p class="tc-hero-subtitle">
      Your privacy matters to us. This policy explains what information UMYO
      Gossip collects, how it is used, and the choices you have as a
      participating member of any UMYO Gossip ecosystem.
    </p>
  </div>
</section>

<!-- ============ PRIVACY CONTENT ============ -->
<main class="tc-body">
  <div class="container">
    <div class="tc-wrap">

      <span class="tc-meta">LAST UPDATED · UMYO GOSSIP PLATFORM POLICIES</span>

      <!-- SECTION 1 -->
      <div class="tc-card">
        <div class="tc-num">01</div>
        <h2 class="tc-title">Information We Collect</h2>
        <p>To operate the Platform and its mission-specific ecosystems, the Company collects information you provide directly, information generated through your use of the Platform, and information obtained from third parties.</p>
        <p><strong>Information you provide.</strong> This includes account details such as your name, email address, phone number, profile information, payment information, and any content, messages, or materials you submit within an ecosystem.</p>
        <p><strong>Information collected automatically.</strong> When you access the Platform, the Company may automatically collect device information, log data, IP address, browser type, approximate location, and usage activity such as pages viewed and features used.</p>
        <p><strong>Information from third parties.</strong> The Company may receive information from payment processors, identity-verification providers, business partners, or publicly available sources in connection with your participation in the Platform.</p>
        <div class="tc-highlight">
          UMYO Gossip collects only the information reasonably necessary to operate the Platform, verify eligibility for community programs, and maintain a safe environment across ecosystems.
        </div>
      </div>

      <!-- SECTION 2 -->
      <div class="tc-card">
        <div class="tc-num">02</div>
        <h2 class="tc-title">How We Use Your Information</h2>
        <p>The Company uses collected information for purposes including:</p>
        <ul class="tc-list">
          <li>Creating and administering member accounts and ecosystem access</li>
          <li>Operating, maintaining, and improving the Platform and its features</li>
          <li>Processing registrations, incentive applications, and eligibility verification</li>
          <li>Communicating with members about updates, programs, and policy changes</li>
          <li>Monitoring for fraud, abuse, and violations of Platform or ecosystem policies</li>
          <li>Complying with applicable laws, regulations, and legal requests</li>
        </ul>
        <p>The Company does not sell members' personal information to third parties for their own independent marketing purposes.</p>
      </div>

      <!-- SECTION 3 -->
      <div class="tc-card">
        <div class="tc-num">03</div>
        <h2 class="tc-title">Sharing and Disclosure of Information</h2>
        <p>The Company may share information with:</p>
        <ul class="tc-list">
          <li>Service providers who perform functions on the Company's behalf, such as hosting, payment processing, and identity verification</li>
          <li>Other members, to the extent required for participation within a shared ecosystem</li>
          <li>Business partners involved in the administration of hardship incentive or assistance programs</li>
          <li>Regulators, law enforcement, or other parties when required by law or to protect the rights, safety, or property of the Company or its members</li>
          <li>A successor entity in connection with a merger, acquisition, or sale of assets</li>
        </ul>
        <div class="tc-highlight">
          Service providers and partners are permitted to use member information only as needed to perform their function for the Platform, and are contractually obligated to safeguard that information.
        </div>
      </div>

      <!-- SECTION 4 -->
      <div class="tc-card">
        <div class="tc-num">04</div>
        <h2 class="tc-title">Cookies and Tracking Technologies</h2>
        <p>The Platform uses cookies and similar tracking technologies to recognize returning members, remember preferences, analyze traffic, and improve overall functionality.</p>
        <p>Members may adjust browser settings to refuse or limit cookies; however, doing so may affect the availability of certain features or ecosystem functions.</p>
        <p>The Company does not knowingly permit third parties to use tracking technologies on the Platform for purposes unrelated to operating and improving the Platform.</p>
      </div>

      <!-- SECTION 5 -->
      <div class="tc-card">
        <div class="tc-num">05</div>
        <h2 class="tc-title">Data Security</h2>
        <p>The Company implements administrative, technical, and physical safeguards designed to protect member information against unauthorized access, alteration, disclosure, or destruction.</p>
        <p>No method of transmission or storage is completely secure. While the Company works to protect member information, it cannot guarantee absolute security, and members share responsibility for safeguarding their own account credentials.</p>
        <div class="tc-highlight">
          Members should promptly report any suspected unauthorized access to their account or suspicious Platform activity.
        </div>
      </div>

      <!-- SECTION 6 -->
      <div class="tc-card">
        <div class="tc-num">06</div>
        <h2 class="tc-title">Your Rights and Choices</h2>
        <p>Depending on your location, you may have rights regarding your personal information, including the right to:</p>
        <ul class="tc-list">
          <li>Request access to the personal information the Company holds about you</li>
          <li>Request correction of inaccurate or incomplete information</li>
          <li>Request deletion of your personal information, subject to legal and operational limitations</li>
          <li>Opt out of certain communications or marketing messages</li>
          <li>Withdraw consent where processing is based on consent</li>
        </ul>
        <p>Requests may be submitted through your account settings or by contacting the Company directly. The Company will respond within a reasonable timeframe as required by applicable law.</p>
      </div>

      <!-- SECTION 7 -->
      <div class="tc-card">
        <div class="tc-num">07</div>
        <h2 class="tc-title">Children's Privacy</h2>
        <p>The Platform is not directed to individuals under the age of eighteen (18), and the Company does not knowingly collect personal information from minors.</p>
        <p>If the Company becomes aware that it has inadvertently collected information from a minor, it will take reasonable steps to delete that information from its records.</p>
      </div>

      <!-- SECTION 8 -->
      <div class="tc-card">
        <div class="tc-num">08</div>
        <h2 class="tc-title">Changes to This Policy and Contact</h2>
        <p>The Company may update this Privacy Policy from time to time to reflect changes in its practices, the Platform, or applicable law. Material changes will be communicated through the Platform or by other reasonable means.</p>
        <p>Continued use of the Platform following any update constitutes acceptance of the revised Privacy Policy.</p>
        <div class="tc-highlight">
          Questions, concerns, or requests regarding this Privacy Policy may be directed to the Company through the contact options available on the Platform.
        </div>
      </div>

    </div>
  </div>
</main>

<!-- ============ FOOTER ============ -->
<footer class="site-footer pkg-footer">
  <div class="container-fluid px-3 px-lg-4">
    <div class="row py-5">

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <div class="d-flex align-items-center gap-2 mb-2">
          <img src="assets/images/logo.png" alt="UMYO Gossip" class="brand-logo" onerror="this.style.display='none'">
          <div class="brand-text">UMYO <span class="text-pink">GOSSIP</span></div>
        </div>
        <small class="d-block pkg-footer-muted">YOUR VOICE. YOUR COMMUNITY.<br>POWERED BY UMYO.</small>
      </div>

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <h6 class="pkg-footer-heading">QUICK LINKS</h6>
        <ul class="pkg-footer-links">
          <li><a routerLink="/">Home</a></li>
          <li><a routerLink="/directory">Directory</a></li>
          <li><a routerLink="/packages">Packages</a></li>
          <li><a routerLink="/platforms">Platforms</a></li>
          <li><a routerLink="/hardship">Incentives</a></li>
        </ul>
      </div>

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <h6 class="pkg-footer-heading">RESOURCES</h6>
        <ul class="pkg-footer-links">
          <li><a routerLink="/services">Services</a></li>
          <li><a routerLink="/how-to">How To</a></li>
          <li><a routerLink="/hardship">Hardship Incentives</a></li>
          <li><a href="/privacy">Privacy Policy</a></li>
          <li><a href="/terms">Terms of Service</a></li>
        </ul>
      </div>

      <div class="col-lg-3 col-md-6">
        <h6 class="pkg-footer-heading">LET'S CONNECT</h6>
        <div class="social-icons justify-content-start">
          <a href="#" aria-label="Instagram">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
            </svg>
          </a>
          <a href="#" aria-label="TikTok">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 3v11.5a3.5 3.5 0 1 1-3-3.46"/><path d="M14 3c.4 2.6 2.2 4.4 5 4.8"/>
            </svg>
          </a>
          <a href="#" aria-label="YouTube">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="5" width="20" height="14" rx="4"/><path d="M10 9l6 3-6 3V9Z" fill="currentColor" stroke="none"/>
            </svg>
          </a>
          <a href="#" aria-label="Facebook">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3Z"/>
            </svg>
          </a>
          <a href="#" aria-label="X">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 4l16 16M20 4 4 20"/>
            </svg>
          </a>
        </div>
      </div>

    </div>

    <div class="pkg-footer-bottom text-center py-3">
      <small>© 2026 UMYO Gossip Directory. All Rights Reserved.</small>
    </div>
  </div>
</footer>
